module.exports = __webpack_public_path__ + "static/media/66800013-u1D0wSgs.fc41274e.JPG";